var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdmLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.5568V33.576L7.82789 40L40 12.9336V0L7.82789 26.9808L0 20.5568Z",
    fill: "#5C4400"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 20.5547L24.8601 33.5739L32.516 39.9979L39.9999 33.5739V20.5547Z",
    fill: "#D9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.5054V0L15.3978 12.9336L7.82789 19.3576L0 12.5054Z",
    fill: "#D9A000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdmLogoIcon);
export default __webpack_public_path__ + "static/media/mdm-logo-icon.cb56c3cf4372eb2f93efb15a530e0280.svg";
export { ForwardRef as ReactComponent };